/* @flow */

import React from 'react';
import { Message, Table, Segment } from 'semantic-ui-react';
import DiffusionTarget from './DiffusionTarget';

type Props = {
  isEditable: boolean,
  targets: Array<Target>,
  roles: Array<UserRole>,
  onDelete: (target: Target) => void,
  attached?: boolean,
};

const DiffusionTargets = ({
  isEditable,
  targets,
  roles,
  attached,
  onDelete,
}: Props) => {
  if (targets && targets.length) {
    return (
      <Segment attached={attached || 'bottom'}>
        <Table basic="very">
          <Table.Header fullWidth>
            <Table.Row>
              {isEditable && <Table.HeaderCell />}
              <Table.HeaderCell width={6} textAlign="center">
                Profil
              </Table.HeaderCell>
              <Table.HeaderCell width={10} textAlign="center">
                Tags
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {targets.map(t => (
              <DiffusionTarget
                key={targets.indexOf(t)}
                target={t}
                roles={roles}
                isEditable={isEditable}
                onDelete={onDelete}
              />
            ))}
          </Table.Body>
        </Table>
      </Segment>
    );
  }

  return (
    <Segment attached={attached || 'bottom'}>
      <Message icon="info" header="Liste de diffusion vide. Visible à tous." />
    </Segment>
  );
};

export default DiffusionTargets;



// WEBPACK FOOTER //
// ./src/modules/diffusion/components/DiffusionTargets.js